// api.js

import axiosInstance from "../axiosInstance";

export const ShopifyAppConfigService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/shopify-app-config", {
        ...data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetch: async (limit, skip, searchValue) => {
    try {
      let response = await axiosInstance.get(
        `/shopify-app-config?$limit=${limit || 15}&$skip=${skip || 0}&${
          searchValue ? `&name[$search]=${searchValue}` : ""
        }$sort[createdAt]=-1&$populate[0][path]=client_id&$populate[0][select][0]=business_name&$populate[0][select][1]=email`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/shopify-app-config/${id}`, {
        ...data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/shopify-app-config/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  checkAvailability: async (data) => {
    try {
      let response = await axiosInstance.post(
        "/check-availability-user-and-shop",
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  resendLink: async (clientId, installLink) => {
    try {
      let response = await axiosInstance.post("/resend-installation-link", {
        clientId: clientId,
        installLink: installLink,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deploy: async (configId) => {
    try {
      let response = await axiosInstance.post("/shopify-deploy", {
        configId: configId,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
